<template>
 <div>
    <v-container v-if="!loading && companies.length > 1 && !demoMode" grid-list-md class="pa-0 pt-2" fluid>
      <v-layout row wrap>
        <v-flex md3 xs12>
          <v-select
            v-if="!loading && companies.length > 1 && showOverview"
            :items="filteredCompanies"
            :item-color="companyPrimaryColor"
            :background-color="$vuetify.theme.themes[theme].menu"     
            item-text="name"
            item-value="id"
            hide-details
            v-on:input="loadSurveys()"
            v-model="activeComp"
            no-data-text="Geen bedrijven gevonden."
            label="Selecteer bedrijf"
            outlined
            dense
            >
            <template v-slot:prepend-item>
              <v-list-item>
                <v-list-item-content  class="pt-0" >
                  <v-text-field
                    :color="companyPrimaryColor"
                    placeholder="Zoeken"
                    prepend-inner-icon="search"
                    clearable
                    v-model="searchCompanies"
                    hide-details
                    dense
                  ></v-text-field>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <div v-if="searchCompanies && searchCompanies.length > 0" style="padding: 4px 17px 3px 17px; background-color:rgba(0,0,0, 0.02); color: rgba(0, 0, 0, 0.6); text-align: center; font-size: 12px">{{ filteredCompanies.length }} van {{ companies.length }} bedrijven</div>
              <v-divider v-if="searchCompanies && searchCompanies.length > 0"></v-divider>
            </template>
          </v-select>

          <div class="header-select-button" v-if="!showOverview">
            <v-btn small fab dark depressed :color="companySecondaryColor"  @click="backToOverview()">
              <v-icon large darken>chevron_left</v-icon>
            </v-btn>
            <span  v-for="company in companies" :key="company.id">
              <span class="journey-header-comp" v-if="company.id == activeComp">{{ company.name }}</span>
            </span>
          </div>
        </v-flex>
      </v-layout>
    </v-container>

    <div v-if="loading || surveyLoading" class="blackbox-loader"></div>

    <v-card class="mt-4" outlined v-if="showOverview == true && loading == false">
      <v-card-title>
        <h4>Surveys van {{ activeCompData.name }}</h4>
        <v-spacer></v-spacer>
        <v-btn fab dark :color="companyPrimaryColor" @click="newSurveyDialog = true">
          <v-icon darken>add</v-icon>
        </v-btn>
      </v-card-title>

      <div v-if="this.surveys.length > 0">
        <v-data-table
          :headers="headerJourneys"
          :items="surveys"
          :itemsPerPage.sync="journeyPages"
          hide-default-footer
          >
          <template v-slot:item="{item}">
            <tr>
              <td>{{ item.name }}</td>
              <td>{{ item.description }}</td>
              <td>
                <v-btn style="float: right;" icon class="mx-0" @click="selectSurvey(item)">
                  <v-icon large :style="{color: $vuetify.theme.themes[theme].text}">chevron_right</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>

      <div class="no-content text-center"  v-else> 
        <p>Nog geen surveys toegevoegd</p>
        <v-btn dark :color="companyPrimaryColor" @click="newSurveyDialog = true">Survey toevoegen</v-btn>
      </div>
    </v-card>

    <div class="special-content-box mt-4" v-show="activeSurvey && showOverview == false && surveyLoading == false">
      <tabs :options="{ useUrlFragment: false }">
        <tab name="Algemeen" class="first">
            <div class="mb-4 pa-2">
              <v-container grid-list-md class="pa-4 ma-0" style="max-width: none">
                <v-layout row wrap>
                  <v-flex md6 xs12>
                    <h2>Algemeen</h2>
                  </v-flex>
                  <v-flex md6 xs12 >
                    <div style="display: inline-block; float: right;">
                      <v-btn rounded color="secondary" class="modal-button-next" :dark="changed" :loading="savingSurvey" :disabled="!changed" :depressed="!changed" @click="updateSurveyBasic()">
                        <span v-if="changed">Wijzigingen opslaan <v-icon righy>mdi-chevron-right</v-icon></span>
                        <span v-else>Opgeslagen  <v-icon right>mdi-check</v-icon></span>  
                      </v-btn>
                    </div>
                  </v-flex>
                </v-layout>
              </v-container>
              <div class="px-2">
                <v-text-field
                  class="mt-4"
                  outlined
                  dense
                  :color="companyPrimaryColor"
                  hide-details
                  label="Naam"
                  background-color="background"
                  v-model="activeSurvey.name"
                  required
                ></v-text-field>
                <v-text-field
                  class="mt-4"
                  outlined
                  dense
                  :color="companyPrimaryColor"
                  hide-details
                  label="Omschrijving"
                  background-color="background"
                  v-model="activeSurvey.description"
                  required
                ></v-text-field>

                <p class="mt-4 mb-1 pa-0"><strong>Welkomsboodschap</strong></p>
                <div>
                  <ckeditor type="classic" v-model="activeSurvey.intro" :config="editorConfig"></ckeditor>   
                </div>

                <v-textarea
                  class="mt-4"
                  outlined
                  dense
                  rows="3"
                  :color="companyPrimaryColor"
                  label="Disclamer"
                  persistent-hint
                  hint="Wordt weergegeven in de footer"
                  background-color="background"
                  v-model="activeSurvey.disclaimer"
                  required
                ></v-textarea>
              </div>

              <v-card color="background"  flat class="ma-2 pa-2">
                <v-container grid-list-md fluid class="ma-0 pa-0">
                  <h3><strong>Extra instellingen</strong></h3>
                  <v-layout row wrap class="ma-0 pa-0">
                    <v-flex xs12 md6 class="pr-4">
                      <v-switch
                        class="ma-0 my-4 pa-0"
                        :color="companyPrimaryColor"
                        label="Vraag om telefoonnummer"
                        v-model="activeSurvey.askPhone"
                        hide-details
                      ></v-switch>
                      <v-switch
                        class="ma-0 my-4 pa-0"
                        :color="companyPrimaryColor"
                        label="Volgende knop gebruiken om verder te gaan in de survey"
                        v-model="activeSurvey.useNextButton"
                        hide-details
                      ></v-switch>
                      <v-switch
                        class="ma-0 my-4 pa-0"
                        :color="companyPrimaryColor"
                        label="Resultaat laten zien aan einde van de survey"
                        v-model="activeSurvey.showResult"
                        hide-details
                      ></v-switch>
                      <v-text-field
                        class="mt-4"
                        outlined
                        dense
                        :color="companyPrimaryColor"
                        hide-details
                        label="Accentkleur"
                        background-color="menu"
                        v-model="activeSurvey.color"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 md6>
                      <v-switch
                        class="ma-0 my-4 pa-0"
                        :color="companyPrimaryColor"
                        label="Survey koppelen aan Mautic"
                        v-model="activeSurvey.useMautic"
                        hide-details
                      ></v-switch>
                      <v-text-field
                        v-if="activeSurvey.useMautic"
                        class="mt-4"
                        outlined
                        dense
                        :color="companyPrimaryColor"
                        hide-details
                        label="Mautic Url"
                        background-color="menu"
                        v-model="activeSurvey.mauticUrl"
                        required
                      ></v-text-field>
                      <v-text-field
                        v-if="activeSurvey.useMautic"
                        class="mt-4"
                        outlined
                        dense
                        :color="companyPrimaryColor"
                        persistent-hint
                        hint="Deze email wordt verzonden na invullen van de survey"
                        label="Mautic Email ID"
                        background-color="menu"
                        v-model.number="activeSurvey.mauticEmailId"
                        required
                      ></v-text-field>

                      <v-switch
                        class="ma-0 my-4 pa-0"
                        :color="companyPrimaryColor"
                        label="Gebruik bedankpagina"
                        v-model="activeSurvey.useSuccessPage"
                        hide-details
                      ></v-switch>
                      <v-text-field
                        v-if="activeSurvey.useSuccessPage"
                        class="mt-4"
                        outlined
                        dense
                        :color="companyPrimaryColor"
                        hide-details
                        label="Bedankpagina Url"
                        background-color="menu"
                        v-model="activeSurvey.successPageUrl"
                        required
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card>


              <v-card color="background"  flat class="ma-2 pa-2">
                <v-container grid-list-md fluid class="ma-0 pa-0">
                  <h3><strong>URL</strong></h3>
                  <v-layout row wrap class="ma-0 pa-0">
                    <v-flex xs12 >
                      <v-text-field
                        class="mt-4"
                        outlined
                        dense
                        readonly
                        :color="companyPrimaryColor"
                        hide-details
                        label="Live-url"
                        background-color="menu"
                        :value="`https://widgetsalonhub.web.app/?companyId=${this.activeCompData.id}&cls=${this.activeSurvey.id}`"
                        required
                      ></v-text-field>
                      <v-text-field
                        class="mt-4"
                        outlined
                        dense
                        readonly
                        :color="companyPrimaryColor"
                        persistent-hint
                        hint="Bij het testen worden gegevens niet doorgestuurd naar Mautic"
                        label="Test-url"
                        background-color="menu"
                        :value="`https://widgetsalonhub.web.app/?companyId=${this.activeCompData.id}&cls=${this.activeSurvey.id}&clst=hogans`"
                        required
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card>
            </div>
        </tab>
        <tab name="Survey">
            <div class="mb-4 pa-2">
              <v-container grid-list-md class="pa-4 ma-0" style="max-width: none">
                <v-layout row wrap>
                  <v-flex md6 xs12>
                    <h2>Vragen en uitkomsten</h2>
                  </v-flex>
                  <v-flex md6 xs12 >
                    <div style="display: inline-block; float: right;">
                      <v-btn rounded color="secondary" class="modal-button-next" :dark="changed" :loading="savingSurvey" :disabled="!changed" :depressed="!changed" @click="updateSurveyBasic()">
                        <span v-if="changed">Wijzigingen opslaan <v-icon righy>mdi-chevron-right</v-icon></span>
                        <span v-else>Opgeslagen  <v-icon right>mdi-check</v-icon></span>  
                      </v-btn>
                    </div>
                  </v-flex>
                </v-layout>
              </v-container>
            </div>

            <div flat outlined class="no-content" v-if="questions.length == 0"> 
              <p>Nog geen vragen toegevoegd</p>
              <v-btn dark :color="companyPrimaryColor" outlined  @click="question.dialog = true">Vraag toevoegen</v-btn>
            </div>

            <div v-else>
              <v-card class="ma-4" flat outlined >
                <v-card-title>
                  Vragen
                  <v-spacer></v-spacer>
                  <v-btn fab dark :color="companyPrimaryColor" @click="question.dialog = true">
                    <v-icon darken>add</v-icon>
                  </v-btn>
                </v-card-title>
                <v-data-table
                  :headers="headersQuestions"
                  :items="questions"
                  itemsPerPage.sync="-1"
                  hide-default-footer
                  >
                  <template v-slot:item="{item}">
                    <tr>
                      <td>{{ item.question }}</td>
                      <td>{{ questionTypeName(item.type) }}</td>
                      <td>
                        <div v-if="item.type != 'textInput'">
                        {{ item.answers.length }}
                        </div>
                      </td>
                      <td>
                        <v-btn style="float: right;" icon class="mx-0" @click="editQuestion(item)">
                          <v-icon small :color="$vuetify.theme.themes[theme].text">edit</v-icon>
                        </v-btn>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-card>

              <v-card flat outlined class="ma-4">
                <v-card-title>
                  Resultaten
                  <v-spacer></v-spacer>
                  <v-btn dark :color="companyPrimaryColor" @click="generateResults('middle')" :loading="resultsLoading">
                    Genereer resultaten
                  </v-btn>
                </v-card-title>

                <div v-if="activeSurvey.results.length > 0 && !resultsLoading" class="pa-2">
                  <v-card flat color="background" class="pa-2 ma-2 my-4" v-for="(result, index) in activeSurvey.results" :key="index">
                    <v-container v-if="result.questions && result.questions.length > 0" grid-list-md class="pa-0 ma-0" fluid>
                      <h3>{{index + 1}}. Vragen en antwoorden</h3>
                      <v-layout row wrap>
                        <v-flex v-for="(question, index) in result.questions" md3 :key="index" xs12>
                          <v-card outlined>
                            <v-list two-line dense class="pa-0 ma-0">
                              <v-list-item class="pa-0 ma-0 px-2" style="min-height: 0px!important">
                                <v-list-item-avatar :size="30" class="my-2">
                                  <v-icon small class="grey lighten-1" dark>mdi-message-question</v-icon>
                                </v-list-item-avatar>
                                <v-list-item-content>
                                  <v-list-item-title>{{ questionName(question.questionId) }}</v-list-item-title>
                                  <v-list-item-subtitle>{{ answerName(question.answerId) }}</v-list-item-subtitle>
                                </v-list-item-content>
                              </v-list-item>
                            </v-list>
                          </v-card>
                        </v-flex>
                      </v-layout>
                    </v-container>

                    <h4 class="mt-4">Resultaat</h4>

                    <v-text-field
                      v-if="activeSurvey.showResult"
                      class="mt-2 mb-4"
                      outlined
                      dense
                      :color="companyPrimaryColor"
                      hide-details
                      label="Titel"
                      background-color="menu"
                      v-model="result.title"
                      required
                    ></v-text-field>

                    <ckeditor class="mt-4" type="classic" v-model="result.text" :config="editorConfig"></ckeditor>
                    <div class="custom-counter" v-if="result.text" :class="{'alert' : result.text.length > 350}"> {{ result.text.length}}/350</div>
                    <!-- <v-textarea
                      class="mt-4"
                      rows="2"
                      outlined
                      dense
                      :color="companyPrimaryColor"
                      hide-details
                      label="Resultaat"
                      background-color="menu"
                      v-model="result.text"
                      required
                    ></v-textarea> -->
                  </v-card>
                </div>

                <div v-if="activeSurvey.results.length == 0 && !resultsLoading" class="no-content text-center" >
                  <p>Er zijn nog geen resultaten gegenereerd</p>
                </div>

                <div v-if="resultsLoading">
                  <div class="loading-dots">
                    <div class="loading-dots-loader"></div>
                    <p class="loading-dots-text"></p>
                  </div>
                </div>
                
              </v-card>
            </div>
        </tab>
        <tab name="Resultaten">
          <div v-if="surveyConversionsLoading">
            <div class="loading-dots">
              <div class="loading-dots-loader"></div>
              <p class="loading-dots-text"></p>
            </div>
          </div>
          
          <div v-else class="mb-0 pa-0">
            <v-container grid-list-md class="pa-4 ma-0" style="max-width: none">
              <v-layout row wrap>
                <v-flex md6 xs12>
                  <h2>Resultaten</h2>
                </v-flex>
                <v-flex md6 xs12 class="text-right">
                  <v-btn v-if="selected.length > 0" small :color="companySecondaryColor" fab :dark="!removingSurveys" :loading="removingSurveys" :disabled="removingSurveys" :depressed="removingSurveys" @click="removeSurveys()">
                    <v-icon color="menu">mdi-delete</v-icon>
                  </v-btn>

                </v-flex>
              </v-layout>
            </v-container>
            <div v-if="surveyConversions.length > 0">
              <v-data-table
                v-model="selected"
                :headers="headers"
                :items="surveyConversions"
                show-expand
                :sort-desc="true"
                :page.sync="conversionSelectedPage"
                @page-count="conversionSelectorPages"
                hide-default-footer
                :sort-by.sync="tableOptions.sortBy"
                :items-per-page="50"
                :show-select="adminUser"
                single-expand
                class="conversion-table"
              >
              <template v-slot:item="{ item, index, isSelected, select, expand, isExpanded}" >
                <tr :key="index">
                  <td v-if="userRole == 'superadmin'">
                    <v-icon @click="select(true)" v-if="!isSelected">check_box_outline_blank</v-icon>
                    <v-icon @click="select(false)" v-if="isSelected" >check_box</v-icon>
                  </td>
                  <td>
                    <v-tooltip :disabled="(userRole != 'superadmin') && !demoMode" right style="cursor: pointer;">
                      <template v-slot:activator="{ on }">                           
                        <v-avatar
                          v-on="on"
                          size="32"
                          v-if="item.clientData.device == 'desktop'"
                          :color="$vuetify.theme.themes[theme].background"
                        >
                          <v-icon small :color="$vuetify.theme.themes[theme].text">desktop_windows</v-icon>
                        </v-avatar>
                        <v-avatar
                          v-on="on"
                          size="32"
                          v-else-if="item.clientData.device == 'mobile'"
                          :color="$vuetify.theme.themes[theme].background"
                        >
                          <v-icon small :color="$vuetify.theme.themes[theme].text">phone_iphone</v-icon>
                        </v-avatar>
                        <v-avatar 
                          v-on="on"
                          size="32" 
                          v-else 
                          :color="$vuetify.theme.themes[theme].background"
                          >
                          <span small class="headline" :style="{color: $vuetify.theme.themes[theme].text}">?</span>
                        </v-avatar>
                      </template>
                      <span v-if="item.clientData.userAgent" style="color: #fff"><strong>Device info: </strong>{{ item.clientData.userAgent }} </span>
                      <span v-else style="color: #fff">Geen informatie opgeslagen</span>
                    </v-tooltip> 
                  </td>                     
                  <td>
                    <span>{{ item.timestamp.seconds | moment("D MMM - H:mm")}}u</span>
                  </td>
                  <td>
                    <v-chip color="#eee" dense small style="min-width: 70px;">
                      <v-icon left v-if="item.clientData && !item.clientData.name" small color="#333">star</v-icon>
                      {{ item.clientData.name }}
                    </v-chip>
                  </td>
                  <td>
                    <v-chip small>{{ item.type }}</v-chip>
                  </td>
                  <td>
                  <span v-if="item.source">
                    <v-tooltip right :disabled="!item.originalSource" style="cursor: pointer;">
                      <template v-slot:activator="{ on }">                                             
                        <span v-for="(source, index) in sources" :key="index">
                          <v-chip small :color="source.bgColor.hex" v-if="item.source == source.query"><span :style="{color: source.textColor.hex}">{{source.name}}</span></v-chip>
                        </span>  
                        <v-icon small color="#333"  v-if="item.originalSource" v-on="on">help</v-icon>
                      </template>
                      <span style="color: #fff">Gebruikte bron: src?={{ item.originalSource }}</span>
                    </v-tooltip>
                  </span>
                </td> 
                  <td>
                    <span v-if="item.surveyData && item.surveyData.answers && item.surveyData.answers.length > 0">
                      {{ item.surveyData.answers.length }}
                    </span>
                    <span v-else>
                      -
                    </span>
                  </td>
                  <td>
                    <span v-if="item.surveyData && item.surveyData.surveyResult">
                      <p class="ma-0 pa-0"><strong>{{ item.surveyData.surveyResult.title }}</strong></p>
                      <p class="ma-0 pa-0" v-html="item.surveyData.surveyResult.text"></p>
                    </span>
                  </td>
                  <td>
                    <span v-if="!item.progress.availableForAction && item.progress.completed && item.progress.completedBy == 'user'" style="padding: 3px; display: block; width: 60px; text-align: center; background-color: #8bc34a;">Ja</span>
                    <span v-else-if="!item.progress.availableForAction && item.progress.completed && item.progress.completedBy != 'user' && item.progress.completedBy != 'clientOtherWay'"> <span style="padding: 3px; margin: 0 3px 0 0; display: inline-block; width: 60px; text-align: center; background-color: #8bc34a;">Ja</span><v-icon small color="text">perm_phone_msg</v-icon></span> 
                    <span v-else-if="item.progress.availableForAction && item.progress.onHold"> <span style="padding: 5px; margin: 0 3px 0 0; background-color: #64B5F6; display: inline-block; width: 60px; text-align: center;">Bezig</span> <v-icon small color="text">perm_phone_msg</v-icon></span>
                    <span v-else-if="item.progress.availableForAction && !item.progress.completed"  style="padding: 5px; background-color: #fb8c00; display: block; width: 60px; text-align: center;">Nee</span>
                    <span v-else-if="!item.progress.availableForAction && !item.progress.completed && item.progress.noSuccessReason == 'otherwiseSuccesfull'"> <span style="padding: 3px; margin: 0 3px 0 0; display: inline-block; width: 60px; text-align: center; background-color: #8bc34a;">Ja</span><v-icon small color="text">perm_phone_msg</v-icon></span> </span>
                    <span v-else-if="!item.progress.availableForAction && !item.progress.completed"> <span style="padding: 5px; margin: 0 3px 0 0; background-color: #ff5252; display: inline-block; width: 60px; text-align: center;">Nee</span> <v-icon small color="text">perm_phone_msg</v-icon></span>
                    <span v-else-if="!item.progress.availableForAction && item.progress.completed && item.progress.completedBy == 'clientOtherWay'" ><span style="padding: 3px; margin: 0 3px 0 0; display: inline-block; width: 60px; text-align: center; background-color: #8bc34a;">Ja</span><v-icon dense color="text">mdi-account-arrow-left</v-icon></span> 
                  </td>
                  <td>
                    <div>           
                      <v-btn icon @click="expand(true)" v-if="!isExpanded"><v-icon dark>expand_more</v-icon></v-btn>
                      <v-btn icon @click="expand(false)" v-else><v-icon dark>expand_less</v-icon></v-btn>
                    </div>
                  </td>
                </tr>          
              </template>
              <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length" style="padding: 0!important;">
                  <v-card  flat :style="{backgroundColor: $vuetify.theme.themes[theme].menuhover, borderColor: $vuetify.theme.themes[theme].menuborder}" style="border-bottom: 1px solid;">
                    <v-card-text>
                      <v-container class="extra-conversion-info ma-0 pa-0" grid-list-md fluid>
                        <v-layout row wrap class="ma-0 pa-0">
                          <v-flex md6 xs12>
                            <div class="conversion-client-info clear">
                              <h3 style="font-weight: bold;">Contactgegevens</h3>
                              <div><span class="info-label">Naam:</span> <span class="info-data" v-if="item.clientData.name"> {{ item.clientData.name }}</span><span class="info-data" v-else> - </span></div>
                              <div><span class="info-label">Email:</span> <span class="info-data"  v-if="item.clientData.email">{{ item.clientData.email }}</span><span class="info-data" v-else> - </span></div>
                              <div><span class="info-label">Telefoon:</span> <span class="info-data"  v-if="item.clientData.phone">{{ item.clientData.phone }}</span><span class="info-data" v-else> - </span></div>

                              <div v-if="(userRole == 'superadmin' && !demoMode)"><span class="info-label">IP-adres:</span> <span class="info-data"  v-if="item.clientData.ip && item.clientData.ip.query">{{ item.clientData.ip.query }}</span><span class="info-data" v-else> - </span></div>
                            </div>
                          </v-flex>
                          <v-flex md6 xs12>
                            <h3 style="font-weight: bold;">Vragen en antwoorden</h3>
                            <div v-if="item.surveyData.answers && item.surveyData.answers.length > 0">
                              <v-card outlined v-for="answeredQuestion in item.surveyData.answers">
                                <v-list two-line dense class="pa-0 ma-0">
                                  <v-list-item class="pa-0 ma-0 px-2" style="min-height: 0px!important">
                                    <v-list-item-avatar :size="30" class="my-2">
                                      <v-icon small class="grey lighten-1" dark>mdi-message-question</v-icon>
                                    </v-list-item-avatar>
                                    <v-list-item-content>
                                      <v-list-item-title>{{ questionName(answeredQuestion.questionId) }}</v-list-item-title>
                                      <v-list-item-subtitle>{{ answerName(answeredQuestion.answerId) }}</v-list-item-subtitle>
                                    </v-list-item-content>
                                  </v-list-item>
                                </v-list>
                              </v-card>
                            </div>
                            <div v-if="item.surveyData && item.surveyData.surveyResult">
                              <h3 style="font-weight: bold;" class="mt-4 mb-0">Resultaat</h3>
                              <v-card outlined class="pa-4">
                                <p class="ma-0 pa-0"><strong>{{ item.surveyData.surveyResult.title }}</strong></p>
                                <p class="ma-0 pa-0" v-html="item.surveyData.surveyResult.text"></p>
                              </v-card>
                            </div>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card-text>
                  </v-card>
                </td>
              </template>
              </v-data-table>

              <div v-if="surveyConversions.length > 50">
                <v-divider></v-divider>
                <div class="text-center pa-4" >
                  <v-pagination
                    circle
                    v-model="conversionSelectedPage"
                    :length="conversionSelectorPages"
                    :total-visible="9"
                  ></v-pagination>
                </div>
              </div>
            </div>
            <div v-else class="pa-4 ma-4 text-center">
              <div class="hipster-image" :class="randomHipster"></div>
              <p class="pt-2">Geen resultaten gevonden.</p>
            </div> 
          </div>

          
        </tab>
      </tabs>
    </div>

    <!-- / New Survey Dialog \ -->
    <v-dialog v-model="newSurveyDialog" scrollable max-width="600px">
      <add-survey-form :showDialog="newSurveyDialog" :activeComp="activeCompData" :companies="companies"  @newSurveyDialogChange="newSurveyDialog = $event" @updateData="loadSurveys()"></add-survey-form>
    </v-dialog>
    <!-- \ New Survey Dialog / -->

    <!-- / Answer Dialog \ -->
    <v-dialog v-model="answer.dialog" scrollable max-width="500px">
      <v-card>
        <v-card-title class="pr-2" :style=" { backgroundColor: companyPrimaryColor }">
          <h2 v-if="answer.type =='new'" style="color:white">Voeg een nieuwe antwoord toe</h2>
          <h2 v-else style="color:white">Antwoord bewerken</h2>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closeAnswerDialog()" :disabled="answer.saving">
            <v-icon dark color="white">close</v-icon>
          </v-btn>
        </v-card-title>

        <v-alert class="ma-0 pa-2" v-if="answer.feedback" :value="true" type="warning">{{ answer.feedback }} </v-alert>
        <v-divider></v-divider>

        <v-card-text>
          <v-text-field
            class="mt-4"
            outlined
            dense
            :color="companyPrimaryColor"
            hide-details
            label="Antwoord"
            background-color="background"
            v-model="answer.text"
            counter
            maxlength="100"
            required
          ></v-text-field>

          <div v-if="question.type == 'multiImages'" class="upload-image-wrapper clear pt-4">
            <div class="logo-upload-preview" v-if="answer.imageUrl">
               <v-img
                :src="answer.imageUrl"
                aspect-ratio="1"
                contain
                class="grey lighten-4"
                >
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </div>
          <v-btn raised class="primary" @click="onFileSelect">Kies afbeelding</v-btn>
          <input
            type="file"
            style="display: none;"
            ref="fileInput"
            accept="image/*"
            @change="onFilePicked">
          </div>
      </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-container grid-list-md fluid class="ma-0 pa-0">
            <v-layout row wrap class="ma-0 pa-0">
              <v-flex xs12 md6 class="text-left" v-if="$vuetify.breakpoint.name != 'sm' && $vuetify.breakpoint.name != 'xs'">
                <v-btn
                  outlined
                  depressed
                  :disabled="answer.saving"
                  color="#8B93A6"
                  @click="closeAnswerDialog()"
                  >
                  Annuleren
                </v-btn>
              </v-flex>
              <v-flex xs12 md6 class="text-right">
                <v-btn
                  dark
                  rounded
                  :loading="answer.saving"
                  :block="$vuetify.breakpoint.name == 'sm' || $vuetify.breakpoint.name == 'xs'"
                  :color="companySecondaryColor"
                  @click="saveAnswer()"
                  >
                  <span v-if="answer.type =='new'">Antwoord toevoegen</span>
                  <span v-else>Opslaan</span>
                  <v-icon right dark>chevron_right</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- \ Answer Dialog / -->

    <!-- / Condition Dialog \ -->
    <v-dialog v-model="relatedQuestion.dialog" scrollable max-width="500px">
      <v-card>
        <v-card-title class="pr-2" :style=" { backgroundColor: companyPrimaryColor }">
          <h2 style="color:white">Vraag weergeven na:</h2>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closeConditionDialog()" :disabled="answer.saving">
            <v-icon dark color="white">close</v-icon>
          </v-btn>
        </v-card-title>

        <v-alert class="ma-0 pa-2" v-if="relatedQuestion.feedback" :value="true" type="warning">{{ relatedQuestion.feedback }} </v-alert>
        <v-divider></v-divider>

        <v-card-text>
          <v-select
            class="mt-4"
            outlined
            :color="companyPrimaryColor"
            :item-color="companyPrimaryColor"
            hide-details
            label="Vraag"
            v-model="relatedQuestion.question"
            prepend-inner-icon="info"
            background-color="background"
            :items="previousQuestions"
            item-text="question"
            return-object
            item-value="id"
            required
          ></v-select>
          <v-select
            v-if="relatedQuestion.question && relatedQuestion.question.id != 'start' && relatedQuestion.question.type != 'inputText'"
            class="mt-4"
            outlined
            :color="companyPrimaryColor"
            :item-color="companyPrimaryColor"
            hide-details
            label="Antwoord"
            v-model="relatedQuestion.answer"
            prepend-inner-icon="info"
            background-color="background"
            :items="previousQuestionsAnswers"
            item-text="text"
            item-value="id"
            required
          ></v-select>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-container grid-list-md fluid class="ma-0 pa-0">
            <v-layout row wrap class="ma-0 pa-0">
              <v-flex xs12 md6 class="text-left" v-if="$vuetify.breakpoint.name != 'sm' && $vuetify.breakpoint.name != 'xs'">
                <v-btn
                  outlined
                  depressed
                  color="#8B93A6"
                  @click="closeConditionDialog()"
                  >
                  Annuleren
                </v-btn>
              </v-flex>
              <v-flex xs12 md6 class="text-right">
                <v-btn
                  rounded
                  :dark="!relatedQuestionInvalid"
                  :disabled="relatedQuestionInvalid"
                  :block="$vuetify.breakpoint.name == 'sm' || $vuetify.breakpoint.name == 'xs'"
                  :color="companySecondaryColor"
                  @click="saveCondition()"
                  >
                  Toevoegen
                  <v-icon right dark>chevron_right</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- \ Condition Dialog / -->

    <!-- /  Question Dialog \ -->
    <v-dialog v-model="question.dialog" scrollable max-width="600px">
      <v-card>
        <v-card-title class="pr-2" :style=" { backgroundColor: companyPrimaryColor }">
          <h2 v-if="question.dialogType == 'new'" style="color:white">Voeg een nieuwe vraag toe</h2>
          <h2 v-else style="color:white">Vraag wijzigen</h2>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closeQuestionDialog()">
            <v-icon dark color="white">close</v-icon>
          </v-btn>
        </v-card-title>

        <v-alert class="ma-0 pa-2" v-if="question.feedback" :value="true" type="warning">{{ question.feedback }} </v-alert>
        <v-divider></v-divider>

        <v-card-text>
          <v-form lazy-validation>
            <v-text-field
              class="mt-4"
              outlined
              :color="companyPrimaryColor"
              hide-details
              label="Vraag"
              background-color="background"
              v-model="question.question"
              counter
              maxlength="100"
              required
            ></v-text-field>
            <v-select
              class="mt-4"
              outlined
              :color="companyPrimaryColor"
              :item-color="companyPrimaryColor"
              hide-details
              label="Stage"
              v-model="question.type"
              prepend-inner-icon="info"
              background-color="background"
              :items="questionTypes"
              item-text="name"
              item-value="id"
              required
            ></v-select>

            <v-card outlined class="mt-4 answers-card" v-if="question.type != 'textInput'" style="overflow: hidden"> 
              <div v-if="question.answers.length > 0" >
                <div class="pa-2" style="text-align: center; font-weight: bold; font-size: 18px;">Antwoorden</div>
                <div v-if="question.type == 'multiText'">
                  <v-divider class="pa-0 ma-0"></v-divider>
                  <v-list dense class="pa-0 ma-0" id="answers-wrapper" >
                    <div v-for="(answer, index) in question.answers" :key="index + watcher">
                      <v-list-item color="primary">
                      <v-list-item-icon class="handle">
                          <v-icon class="pt-3 mt-2" color="grey lighten-1">drag_indicator</v-icon>
                        </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>{{ answer.text}}</v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-row no-gutters>
                          <v-col sm="6">
                            <v-btn icon @click="editAnswer(answer)">
                              <v-icon small color="grey lighten-1">mdi-pencil</v-icon>
                            </v-btn>
                          </v-col>
                          <v-col sm="6">
                            <v-btn icon @click="deleteAnswer(answer.id)">
                              <v-icon small color="grey lighten-1">mdi-delete</v-icon>
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-list-item-action>
                    </v-list-item>
                    <v-divider class="pa-0 ma-0"></v-divider>
                    </div>
                  </v-list>
                </div>
                <div v-if="question.type == 'multiImages'" >
                  <v-container class="ma-0 mt-0 pa-0" >
                    <v-row no-gutters id="answers-wrapper">
                      <v-col sm="4" v-for="(answer, index) in question.answers" :key="index + watcher">
                        <v-card outlined flat class="ma-1" style="position: relative">
                          <div style="position: absolute; top: 5px; left: 0px; z-index: 99" class="handle">
                            <v-btn fab x-small class="mr-3">
                              <v-icon small color="text lighten-1">drag_indicator</v-icon>
                            </v-btn>
                          </div>
                          <div style="position: absolute; top: 5px; right: 0px; z-index: 99">
                            <v-row no-gutters>
                              <v-col sm="6">
                                <v-btn fab x-small class="mr-3" @click="editAnswer(answer)">
                                  <v-icon small color="text lighten-1">mdi-pencil</v-icon>
                                </v-btn>
                              </v-col>
                              <v-col sm="6">
                                <v-btn fab x-small @click="deleteAnswer(answer.id)">
                                  <v-icon small color="text lighten-1">mdi-delete</v-icon>
                                </v-btn>
                              </v-col>
                            </v-row>
                          </div>
                          <v-img
                            height="200"
                            :src="answer.imageUrl"
                          ></v-img>
                          <v-card-title class="pa-0 ma-1" style="text-align: center; display: block">{{ answer.text }}</v-card-title>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-container>
                </div>
              </div>
              <div class="pt-4 pb-0 text-center" v-else> 
                <p class="ma-0 pa-0 mb-2">Nog geen antwoorden toegevoegd</p>
              </div>
              <div class="pt-2 pb-4 text-center"> 
                <v-btn dark small fab :color="companyPrimaryColor" @click="answer.dialog = true"><v-icon darken>add</v-icon></v-btn>
              </div>
            </v-card>

            <v-card outlined class="mt-4 answers-card" v-if="question.type != 'textInput'" style="overflow: hidden">
              <div class="pa-2" style="text-align: center; font-weight: bold; font-size: 18px;">Wanneer vraag weergeven?</div> 
              <div v-if="question.showConditions && question.showConditions.length > 0">
                <v-list dense class="pa-0 ma-0">
                  <v-divider class="pa-0 ma-0"></v-divider>
                  <div v-for="(condition, index) in question.showConditions" :key="index">
                    <v-list-item color="primary">
                    <v-list-item-content>
                      <v-list-item-title><strong>{{ questionName(condition.questionId)}}</strong></v-list-item-title>
                      <v-list-item-subtitle>{{ answerName(condition.answerId)}}</v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-btn icon @click="deleteCondition(condition.questionId, condition.answerId)">
                        <v-icon small color="grey lighten-1">mdi-delete</v-icon>
                      </v-btn>
                    </v-list-item-action>
                  </v-list-item>
                  <v-divider class="pa-0 ma-0"></v-divider>
                  </div>
                </v-list>
              </div>
              <div class="pt-4 pb-0 text-center" v-else> 
                <p class="ma-0 pa-0 mb-2">Nog geen condities toegevoegd</p>
              </div>
              <div class="pt-2 pb-4 text-center"> 
                <v-btn dark small fab :color="companyPrimaryColor" @click="relatedQuestion.dialog = true"><v-icon darken>add</v-icon></v-btn>
              </div>
            </v-card>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-container grid-list-md fluid class="ma-0 pa-0">
            <v-layout row wrap class="ma-0 pa-0">
              <v-flex xs12 md6 class="text-left" v-if="$vuetify.breakpoint.name != 'sm' && $vuetify.breakpoint.name != 'xs'">
                <v-btn
                  outlined
                  depressed
                  color="#8B93A6"
                  @click="closeQuestionDialog()"
                  >
                  Annuleren
                </v-btn>
              </v-flex>
              <v-flex xs12 md6 class="text-right">
                <v-btn
                  dark
                  rounded
                  :block="$vuetify.breakpoint.name == 'sm' || $vuetify.breakpoint.name == 'xs'"
                  :color="companySecondaryColor"
                  @click="saveQuestion()"
                  >
                  <span v-if="question.dialogType == 'new'">Vraag toevoegen</span>
                  <span v-else>Opslaan</span>
                  <v-icon right dark>chevron_right</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-actions>

      </v-card>
    </v-dialog>
    <!-- \ New Question Dialog / -->

  </div>
</template>


<script>
import { bus } from "../main";
import firebase from "firebase/app";
import db from "../firebase/init";
import Sortable from "sortablejs";
import draggable from "vuedraggable";
import moment from "moment";
import uniqid from "uniqid";

import AddSurveyForm from "../components/modals/AddSurveyForm.vue";

export default {
  components: {
    "add-survey-form": AddSurveyForm,
  },
  name: "surveys",
  data: () => ({
    isLoaded: false,

    editorConfig: {
      // plugins: [WordCount ], 
      toolbar: ['heading', 'bold', 'italic', 'bulletedList', 'numberedList',  '|', 'link' ,  '|', 'insertTable', "|", 'undo', "redo", ], 
      table: {
        contentToolbar: [ 'tableColumn', 'tableRow', 'mergeTableCells' ]
      },
    },
    answer: {
      dialog: false,
      id: null,
      feedback: null,
      imageUrl: null,
      image: null,
      type: "new",
      text: "",
      uploading: false,
      uploadProgress: null,
      saving: false,
    },
    relatedQuestion: {
      feedback: null,
      dialog: false,
      question: null,
      answer: null,
    },
    tableOptions: {
      sortBy: "timestampUnix",
      itemsPerPage: 20,
      sortDesc: false
    },
    headers:[
        {
          text: "",
          align: "left",
          value: "clientData",
          width: "50px"
        },
        {
          text: "Datum",
          align: "left",
          value: "timestampUnix",
          width: "150px"
        },
        {
          text: "Naam",
          align: "left",
          value: "clientData.name",
           width: "180px"
        },
        {
          text: "Type",
          align: "left",
          value: "type",
          width: "100px"
        },
        {
          text: "Bron",
          align: "left",
          value: "source",
          width: "120px"
        },
        {
          text: "Vragen beantwoord",
          align: "left",
          value: "source",
          width: "150px"
        },
        {
          text: "Resultaat",
          align: "left",
          value: "source"
        },
        {
          text: "Succes",
          align: "left",
          value: "progress.completed",
          width: "100px"
        },
        {
          text: "",
          value: "data-table-expand",
          align: "right",
          width: "80px",
          sortable: false
        }
      ],
    savingSurvey: false,
    conversionSelectedPage: 1,
    showOverview: true,
    searchCompanies: "",
    search: "",
    today: null,
    newSurveyDialog: false,
    question: {
      dialogType: "new",
      dialog: false,
      showConditions: new Array(),
      feedback: null,
      question: "",
      type: "multiText",
      answers: new Array()
    },
    questionTypes: [
      {
        id: "multiText",
        name: "Meerkeuze met text"
      },
      {
        id: "multiImages",
        name: "Meerkeuze met afbeeldingen"
      },
      {
        id: "textInput",
        name: "Tekstveld"
      },
    ],
    journeyPages: -1,
    activeCompData: {},
    activeCompDataOriginal: {},
    activeComp: "",
    activeCompName: "",
    activeSurvey: {},
    activeSurveyOriginal: {},
    removingSurveys: false,
    selected: [],
    branches: [],
    companies: [],
    questions: [],
    surveys: [],
    pagination: {
      sortBy: "order",
      rowsPerPage: "20"
    },
    headerJourneys: [
      {
        text: "Name",
        align: "left",
        value: "name",
        sortable: true
      },
      {
        text: "Omschrijving",
        align: "left",
        value: "description",
        sortable: false
      },
      {
        sortable: false,
        width: "60px"
      }
    ],
    averageConversionTime: 300,
    resultsLoading: false,
    headersQuestions: [
      {
        text: "Vraag",
        align: "left",
        value: "question",
        sortable: false
      },
      {
        text: "Type",
        align: "left",
        value: "type",
        sortable: false
      },
      {
        text: "Antwoorden",
        align: "Left",
        value: "answers",
        sortable: false
      },
      {
        value: "edit",
        sortable: false
      }
    ],
    sourcesOriginal: [
      {
        query: 'nosource',
        name: 'Organisch',
        bgColor: {
          hex: '#cecece'
        },
        textColor: {
          hex: '#333'
        }
      },
      {
        query: 'unknown',
        name: 'Onbekend',
        bgColor: {
          hex: '#ccc'
        },
        textColor: {
          hex: '#333'
        }
      },
      {
        query: 'mc',
        name: 'Mailchimp',
        bgColor: {
          hex: '#ffe01b'
        },
        textColor: {
          hex: '#333'
        }
      },
      {
        query: 'adw',
        name: 'Adwords',
        bgColor: {
          hex: '#1a73e8'
        },
        textColor: {
          hex: '#fff'
        }
      }
    ],
    watcher: 0,
    loading: true,
    surveyLoading: false,
    results: new Array(),
    surveyConversions: new Array(),
    surveyConversionsLoading: false,
  }),

  created() {
    this.loadUserComp();
    this.today = moment().unix();
  },

  methods: {
    backToOverview() {
      this.questions = new Array()
      this.stages = [];
      this.showOverview = true;
      this.results = new Array();
      this.surveyConversions = new Array();
    },

    loadUserComp() {
      this.userDataLoaded = false;
      let userCompanies = this.userCompanies;
      this.companies = [];
      let counter = 0

      new Promise((resolve, reject)=>{
        if(this.userRole == 'superadmin'){
          db.collection("companies")
          .get()
          .then(snap => {
            this.companies = [];
            snap.forEach(doc => {
              let company = doc.data();
              company.id = doc.id;
              this.companies.push(company);
            });
          })
          .then(()=>{
            resolve();
          })
        }
        else{
          this.userCompanies.forEach(company=>{
          db.collection("companies").doc(company).get()
            .then(doc => {
              let company = doc.data();
              company.id = doc.id;
              this.companies.push(company);
              counter++
              if(counter == this.userCompanies.length){
                resolve()
              }
            })
          })
        }
      })
      .then(()=>{
        // REMEMBER SELECTED COMPANY FROM LOCAL STORAGE
        if(this.userRole == 'superadmin'){
          // Super Admins have access to multiple companies 
          let selectedCompany = window.localStorage.getItem('selectedCompany')

          // Check if a selected company is set in the Local Storage
          if(selectedCompany){
            
            // Check if the selected company is an option
            let selectedCompanyIndex = _.findIndex(this.companies, { 'id': selectedCompany })

            // Selected company is an option, set activeComp
            if(selectedCompanyIndex >= 0){
              this.activeComp = this.companies[selectedCompanyIndex].id;
              this.activeCompJourneys = this.companies[selectedCompanyIndex].journeys;
              this.activeCompName = this.companies[selectedCompanyIndex].name;
              this.loadSurveys();
            } 
            // Selected company is no option, set first company as activeComp 
            else{
              window.localStorage.setItem('selectedCompany', this.companies[0].id)
              this.activeComp = this.companies[0].id;
              this.activeCompJourneys = this.companies[0].journeys;
              this.activeCompName = this.companies[0].name;
              this.loadSurveys();
            }
          }
          // No selected company is set 
          else {
            this.activeComp = this.companies[0].id;
            window.localStorage.setItem('selectedCompany', this.companies[0].id)
            this.loadSurveys();
          }
        }

        // Regular users have 1 company, just get the first
        else {
          this.activeComp = this.companies[0].id;
          this.activeCompJourneys = this.companies[0].journeys;
          this.activeCompName = this.companies[0].name;
          this.loadSurveys();
        }
      })
    },

    loadActiveCompData() {
      this.sources = _.cloneDeep(this.sourcesOriginal)
      db.collection("companies")
        .doc(this.activeComp)
        .get()
        .then(doc => {
          if (doc.exists) {
            this.activeCompData = doc.data();
            this.activeCompData.id = doc.id;
          } else {
            console.log("No such document!");
          }
        })
        .then(() => {
          if(this.activeCompData.conversion.sources.length > 0){
            this.activeCompData.conversion.sources.forEach(sourceItem=>{
              this.sources.push(sourceItem)
            })
          }
          this.activeCompDataOriginal = _.cloneDeep(this.activeCompData);
        })
        .catch(error => {
          console.log("Error getting document:", error);
        });
    },

    // SURVEYS
    loadSurveys() {
      window.localStorage.setItem('selectedCompany', this.activeComp)
      this.loadActiveCompData();

      db.collection("widgetSurveys")
        .where("companyId", "==", this.activeComp)
        .get()
        .then(snap => {
          this.surveys = [];
          snap.forEach(doc => {
            let survey = doc.data();
            survey.id = doc.id;
            this.surveys.push(survey);
          });
        })
        .then(() => {
          this.loading = false;
        });
    },

    async generateResults(type){
      this.resultsLoading = true;
      this.results = new Array();
      // Find first Question
      let firstQuestion = null;
      await new Promise((resolve, reject)=>{
        this.questions.forEach(question=>{
        if(!question.showConditions || question.showConditions.length == 0){
           firstQuestion = question;
           resolve()
          }
          counter++
          if(counter == this.questions.length && !firstQuestion){
            reject()
          }
        })
      })
      .then(()=>{
        firstQuestion.answers.forEach(answer=>{
          let sourceQuestions = new Array();
          this.getNextQuestion(sourceQuestions, firstQuestion, answer)
        })
      })
      .catch(error=>{
        // this.resultsLoading = false;
      })
      this.activeSurvey.results = this.activeSurvey.results ? this.activeSurvey.results : new Array();

      let newResults = new Array()
      // let newResultsFirebase = new Array()
      new Promise((resolve)=>{
        let resultCounter = 0
        this.results.forEach(result=>{
          let id = "";
          new Promise((resolve)=>{
            let counter = 0;
            result.forEach(resultItem=>{
              id = id + resultItem.answerId
              counter++
              if(counter == result.length){
                resolve()
              }
            })
          })
          .then(()=>{
            resultCounter++
              if(resultCounter == this.results.length){
                resolve()
              }
            // Check if result Id already exist in activeSurvey.results
            let index = _.findIndex(this.activeSurvey.results, {'id': id})
            if(index >= 0){
              let resultItem = _.cloneDeep(this.activeSurvey.results[index])
              resultItem.questions = result;
              newResults.push(resultItem);
            }
            else{
              newResults.push({
                id: id,
                title: "",
                text: "",
                questions: result
              })
            }
          })
        })
      })
      .then(()=>{
        this.activeSurvey.results = _.cloneDeep(newResults);
        if(type == 'first'){
          this.activeSurveyOriginal = _.cloneDeep(this.activeSurvey);
        }
        this.resultsLoading = false;
      })
    },

    async removeSurveys(){
      this.removingSurveys = true;
      await new Promise((resolve)=>{
        let counter = 0;
        this.selected.forEach((item)=>{
          let index = _.findIndex()
          db.collection("surveyConversion").doc(item.id).delete()
          .then(()=>{
            counter++
            if(counter == this.selected.length){
              resolve();
            }
          })
          .catch((error)=>{
            console.log("Error removing surveyConversion: ", error)
          })
        })
      })
      .then(()=>{
        this.removingSurveys = false;
      })

      await new Promise((resolve)=>{
        this.surveyConversionsLoading = true;
        let counter = 0;
        this.selected.forEach((item)=>{
          let index = _.findIndex(this.surveyConversions, {'id': item.id})
          if(index >= 0){
            this.surveyConversions.splice(index,1)
          }
          counter++
          if(counter == this.selected.length){
            resolve();
          }
        })
      })
      .then(()=>{
        this.surveyConversionsLoading = false;
        this.selected = new Array();
      })
    },


    getNextQuestion(sourceQuestions, sourceQuestion, sourceAnswer){
      let source = _.cloneDeep(sourceQuestions)
      let counter = 0;
      let matches = 0;
      this.questions.forEach(question=>{
        counter++
        question.showConditions.forEach(condition=>{
          if(condition.questionId == sourceQuestion.id && condition.answerId == sourceAnswer.id){
            matches++
            source.push({
              questionId: sourceQuestion.id,
              answerId: sourceAnswer.id,
            })
            question.answers.forEach(answer=>{
              this.getNextQuestion(source, question, answer)
            })
          }
        })
        if(counter == this.questions.length && matches == 0){
          source.push({
            questionId: sourceQuestion.id,
            answerId: sourceAnswer.id,
          })
          this.results.push(source)
        }
      })
    },

    questionTypeName(id){
      if(id){  
        let name = null;
        let index = _.findIndex(this.questionTypes, {'id': id})
        if(index >= 0){
          name =  this.questionTypes[index].name;
        }
        return name;
      }
      else{
        return null;
      }
    },

    questionName(id){
      if(id){  
        let name = null;
        let index = _.findIndex(this.questions, {'id': id})
        if(index >= 0){
          name =  this.questions[index].question;
          return name;
        }
        if(id == "start"){
          return "Start";
        }
      }
      else{
        return null;
      }
    },

    answerName(id){
      if(id){  
        let name = null;
        let index = _.findIndex(this.availableAnswers, {'id': id})
        if(index >= 0){
          name =  this.availableAnswers[index].text;
        }
        return name;
      }
      else{
        return null;
      }
    },

    selectSurvey(item) {
      this.showOverview = false;
      this.surveyLoading = true;
      this.activeSurvey = item;
      this.questions = _.cloneDeep(this.activeSurvey.questions);
      this.surveyLoading = false;
      if(this.activeSurvey.results && this.activeSurvey.results.length > 0){
        this.generateResults("first");
      }
      else{
        this.activeSurveyOriginal = _.cloneDeep(this.activeSurvey);
      }
      this.getSurveyResults()
    },

    orderAnswers() {
      let element = document.getElementById("answers-wrapper");
      const vm = this;
      Sortable.create(element, {
        handle: ".handle",
        onEnd({ newIndex, oldIndex }) {
          const rowSelected = (vm.question.answers).splice(oldIndex, 1)[0]; // Get the selected row and remove it
          (vm.question.answers).splice(newIndex, 0, rowSelected); // Move it to the new index
          vm.watcher++
          // (this.questions.answers).sort(this.sortQuestions);
        }
      });
    },

    sortQuestions(a, b) {
      // Use toUpperCase() to ignore character casing
      const genreA = a.order;
      const genreB = b.order;

      let comparison = 0;
      if (genreA > genreB) {
        comparison = 1;
      } else if (genreA < genreB) {
        comparison = -1;
      }
      return comparison;
    },

    onFileSelect() {
      this.$refs.fileInput.click();
    },

    onFilePicked(event) {
      this.answer.feedback = null;
      const files = event.target.files;
      this.file = files[0];
      this.answer.filename = files[0].name;
      console.log("files: " + this.answer.filename);
      if (this.answer.filename.lastIndexOf(".") <= 0) {
        this.answer.feedback = "Voeg een geldig bestand toe.";
      }
      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        this.answer.imageUrl = fileReader.result;
      });
      fileReader.readAsDataURL(files[0]);
      this.answer.image = files[0];
      this.answer.feedback = null;
    },

    saveAnswer(){
      let id = this.answer.id ? this.answer.id : uniqid();
      this.answer.saving = true;
      this.answer.feedback = null;
      new Promise((resolve) => {
        if(this.answer.text){
          if(this.question.type == 'multiImages'){
            if(this.answer.imageUrl){
              if(this.answer.image){ // New Image added
                new Promise((resolve, reject) => {
                  console.log("start storen");
                  const file = this.file;
                  let uniqImageId = uniqid()
                  const filename = this.answer.filename;
                  const ext = filename.slice(filename.lastIndexOf("."));
                  const fileUrl = this.activeComp + "/" + "survey/" + this.activeComp.img + uniqImageId + ext;
                  let uploadTask = firebase.storage().ref(fileUrl).put(file);
                  uploadTask.on("state_changed", taskSnapshot => {},
                    error => {
                      console.error("taskSnapshot error: ", error);
                      reject();
                    },() => {
                      uploadTask.snapshot.ref
                        .getDownloadURL()
                        .then(url => {
                          this.answer.imageUrl = url;
                          resolve();
                        })
                        .catch(error => {
                          console.error("uploadTask error: ", error);
                          reject();
                        });
                    }
                  );
                })
                .then(()=>{
                  resolve('save');
                })
              }
              else{
                resolve('save');
              }  
            }
            else{
              this.answer.feedback = "Voeg een afbeelding toe om op te slaan.";
              resolve('none');
            }
          }
          else{
            resolve('save');
          }
        }
        else{
          this.answer.feedback = "Voeg een antwoord toe om op te slaan.";
          resolve('none');
        }
      })
      .then((action)=>{
        this.answer.saving = false;
        if(action == 'save'){
          if(this.answer.type == 'new'){
            this.question.answers.push({
              id: id,
              text: this.answer.text,
              imageUrl: this.answer.imageUrl
            })
          }
          else{
            let index = _.findIndex(this.question.answers, {'id': id });
            if(index >= 0){
              this.question.answers[index].text = this.answer.text;
              this.question.answers[index].imageUrl = this.answer.imageUrl;
            }
            else{
              console.log("Answer not found")
            }
          }
          this.answer = {
            dialog: false,
            feedback: null,
            imageUrl: null,
            image: null,
            type: "new",
            text: "",
            id: null,
            uploading: false,
            uploadProgress: null,
            saving: false,
          }
        }
      })       
    },

    getSurveyResults(){
      this.surveyConversions = new Array();
      this.surveyConversionsLoading = true;
      db.collection("surveyConversion")
        .where('companyId', '==', this.activeCompData.id) 
        .where('surveyData.id', '==', this.activeSurvey.id)
        .orderBy("timestamp", "desc")
        .limit(500)
        .get()
        .then(snap => {
          snap.forEach(doc => {
            let conversion = doc.data();
            conversion.id = doc.id;
            conversion.timestampUnix = doc.data().timestamp.seconds
            let source = _.find(this.sources, { 'query': conversion.source});
            if(source){
              conversion.source = source.query
            }
            else if(doc.data().source && doc.data().source != "notInstalled" && !source){
              conversion.source = 'unknown'
              conversion.originalSource = doc.data().source
            } 
            else {
              conversion.source = 'nosource'
            }
            this.surveyConversions.push(conversion);
          })
        })
        .then(()=>{
          this.surveyConversionsLoading = false;
        })
    },

    editAnswer(answer){
      this.answer.type = "edit";
      this.answer.id = answer.id;
      this.answer.text = answer.text;
      this.answer.imageUrl = answer.imageUrl;
      this.answer.dialog = true;
    },

    deleteAnswer(id){
      let index = _.findIndex(this.question.answers, {'id': id });
      if(index >= 0){
        this.question.answers.splice(index, 1)
      }
      else{
        console.log("Answer not found")
      }
    },

    deleteCondition(questionId, answerId){
      let index = _.findIndex(this.question.showConditions, {'questionId': questionId, 'answerId': answerId });
      if(index >= 0){        
        this.question.showConditions.splice(index, 1)
      }
      else{
        console.log("Condition not found")
      }
    },

    editQuestion(question){
      this.question.dialogType = "edit";
      this.question.id = question.id;
      this.question.type = question.type;
      this.question.question = question.question;
      this.question.showConditions = question.showConditions;
      this.question.answers = question.answers;
      this.question.dialog = true;

      setTimeout(()=>{ 
        this.orderAnswers();
      }, 100);
    },

    closeQuestionDialog(){
      this.question.dialog = false;
      this.question.question = "";
      this.question.showConditions = new Array();
      this.question.answers = new Array();
      this.question.type = "multiText";
      this.question.dialogType = "new";
    },

    closeAnswerDialog(){
      this.answer.dialog = false;
      this.answer.feedback = null;
    },

    closeConditionDialog(){
      this.relatedQuestion.dialog = false;
      this.relatedQuestion.question = null;
      this.relatedQuestion.answer = null;
    },

    saveCondition(){
      this.question.showConditions.push({
        questionId: this.relatedQuestion.question.id,
        answerId: this.relatedQuestion.answer ? this.relatedQuestion.answer : null,
      })
      this.closeConditionDialog();
      this.updateSurveyQuestions();
    },

    saveQuestion(){
      let id = this.question.id ? this.question.id : uniqid();
      this.question.feedback = null;
      let questionsValid = this.question.type == 'textInput' || this.question.answers.length > 1 ? true : false;
      if(this.question.question && questionsValid){
        if(this.question.dialogType == 'new'){
            this.questions.push({
            id: id,
            question: this.question.question,
            answers: this.question.answers,
            showConditions: this.question.showConditions,
            type: this.question.type
          })
        }
        else{
          let index = _.findIndex(this.questions, {'id': id });
          if(index >= 0){
            this.questions[index].question = this.question.question;
            this.questions[index].answers = this.question.answers;
            this.questions[index].type = this.question.type;
            this.questions[index].showConditions = this.question.showConditions ? this.question.showConditions : new Array();
          }
          else{
            console.log("Answer not found")
          }
        }
        this.closeQuestionDialog();
        this.updateSurveyQuestions();
      }
      else{
        this.question.feedback = "Vraag en antwoorden invullen om de vraag op te slaan."
      }
    },

    updateSurveyBasic(){ // Update basis settings and results
      this.savingSurvey = true;
      let cleanedResults = new Array();
      new Promise((resolve)=>{
        let counter = 0;
        this.activeSurvey.results.forEach(result=>{
          cleanedResults.push({
            id: result.id,
            title: result.title,
            text: result.text,
          })
          counter++
          if(counter == this.activeSurvey.results.length){
            resolve()
          }
        })
      })
      .then(()=>{
        db.collection("widgetSurveys").doc(this.activeSurvey.id)
        .set({
          name: this.activeSurvey.name,
          description: this.activeSurvey.description,
          results: cleanedResults,
          disclaimer: this.activeSurvey.disclaimer,
          intro: this.activeSurvey.intro,
          askPhone: this.activeSurvey.askPhone,
          showResult: this.activeSurvey.showResult,
          useNextButton: this.activeSurvey.useNextButton,
          useMautic: this.activeSurvey.useMautic,
          mauticUrl: this.activeSurvey.mauticUrl,
          mauticEmailId: this.activeSurvey.mauticEmailId,
          color: this.activeSurvey.color,
          useSuccessPage: this.activeSurvey.useSuccessPage,
          successPageUrl: this.activeSurvey.successPageUrl
        },{merge: true})
        .then(() => {
          this.activeSurveyOriginal = _.cloneDeep(this.activeSurvey);
          this.savingSurvey = false; 
        })
        .catch(error=>{
          console.error("Error updating Survey: ", error)
          this.savingSurvey = false; 
        })
      })
    },

    updateSurveyQuestions(){ // Update survey questions
      this.savingSurvey = true; 
      db.collection("widgetSurveys").doc(this.activeSurvey.id)
        .set({
          questions: this.questions,
        },{merge: true})
        .then(() => {
          this.activeSurveyOriginal = _.cloneDeep(this.activeSurvey)
          this.savingSurvey = false;  
        })
        .catch(error=>{
          console.error("Error updating Survey: ", error)
          this.savingSurvey = false; 
        })
    },

    // orderStages() {
    //   let element = document.getElementById("stages");
    //   const vm = this;
    //   Sortable.create(element, {
    //     handle: ".handle",
    //     onEnd({ newIndex, oldIndex }) {
    //       const rowSelected = vm.stages.splice(oldIndex, 1)[0]; // Get the selected row and remove it
    //       vm.stages.splice(newIndex, 0, rowSelected); // Move it to the new index
    //       vm.updateOrderStages();
    //     }
    //   });
    // },

    editStage(item) {
      this.editStageDialog = true;
      this.editedIndex = this.stages.indexOf(item);
      this.selectedStageInfo = Object.assign({}, item);
      this.selectedStageInfoOriginal = Object.assign({}, item);

      let exeptions = this.usedStageColors;
      this.usedStageColorsEdit = exeptions.filter(e => e !== item.color);
    },

    updateOrderStages(item) {
      let stages = this.stages;
      stages.forEach(item => {
        let numberItem = stages.indexOf(item);
        // console.log("Update Order: " + item.order + " wordt ArrayIndex: " + numberItem);
        db.collection("stages")
          .doc(item.id)
          .update({
            order: numberItem
          });
      });
    },

    updateOrderQuestions(item) {
      console.log("Update Order");

      let questions = this.questions;
      questions.forEach(item => {
        let numberItem = questions.indexOf(item);
        // console.log("Update Question Order: " + item.order + " wordt ArrayIndex: " + numberItem);
        db.collection("questions")
          .doc(item.id)
          .update({
            order: numberItem
          });
      });
    }
  },

  computed: {
    previousQuestions(){
      let activeQuestion = _.cloneDeep(this.question);
      let previousQuestions = new Array();
      previousQuestions.push({
        id: "start",
        question: "Start"
      })
      this.questions.forEach((question)=>{
        if(activeQuestion.id){
          if(activeQuestion.id != question.id){
            previousQuestions.push(question);
          }
        }
        else{
          previousQuestions.push(question);
        }
      })
      return previousQuestions;
    },

    availableAnswers(){
      let answers = new Array();
      this.questions.forEach((question)=>{
        if(question.type != 'inputText'){
          question.answers.forEach((answer)=>{
            answers.push(answer);
          })
        }
      })
      return answers;
    },

    previousQuestionsAnswers(){
      if(this.relatedQuestion.question && this.relatedQuestion.question.id != 'start' && this.relatedQuestion.question.type != 'inputText'){
        return this.relatedQuestion.question.answers;
      }
      return new Array();
    },

    relatedQuestionInvalid(){
      if(this.relatedQuestion.question){
        if(this.relatedQuestion.question.id == 'start'){
          return false;
        }
        else if(this.relatedQuestion.question && this.relatedQuestion.answer){
          return false;
        }
        else{
          return true;
        }
      }
      else{
        return true;
      }
    },

    conversionSelectorPages(){
      return Math.ceil(this.surveyConversions.length / 50)
    },

    randomHipster(){
      if(this.surveyConversions.length == 0){
        let randomNumber = Math.floor(Math.random() * 12) + 1;
        let hipsterClass = "hipster-" + randomNumber
         return hipsterClass
      } else {
        return null
      }    
    },

    adminUser(){
      if(this.userRole == 'superadmin'){
        return true
      } else {
        return false
      }
    },

    theme(){
      return (this.$vuetify.theme.dark) ? 'dark' : 'light'
    },

    demoMode(){
      return this.$store.state.demoMode;
    },
    
    userPermissions() {
      return this.$store.state.userPermissions;
    },
    userCompanies() {
      return this.$store.state.userCompanies;
    },
    userCompany() {
      return this.$store.state.userCompany;
    },
    userFirstName() {
      return this.$store.state.userFirstName;
    },
    userLastName() {
      return this.$store.state.userLastName;
    },
    userRole() {
      return this.$store.state.userRole;
    },
    companyPrimaryColor() {
      return this.$store.state.companyPrimaryColor;
    },
    companySecondaryColor() {
      return this.$store.state.companySecondaryColor;
    },
    changed() {
      if (_.isEqual(this.activeSurvey, this.activeSurveyOriginal) == false) {
        return true;
      } else {
        return false;
      }
    },
    filteredCompanies(){
      if(this.searchCompanies && this.searchCompanies.length > 0){
        return this.companies.filter(company => {
          return company.name.toLowerCase().includes(this.searchCompanies.toLowerCase());
        });
      } else {
        return this.companies
      }
    }
  }
};
</script>
<style>
.answers-card{
  background-color: var(--v-background-base)!important;
}
.custom-counter{
  font-size: 12px;
}
.custom-counter.alert{
  color: red;
  font-weight: bold;
}
</style>
